module.exports = __webpack_public_path__ + "img/cta_3.6ffc5d86.png";